import JobGridType2Container from "../../../components/job/grid/JobGridType2";

const JobGridType2 = () => {
  return <JobGridType2Container />;
};

export default JobGridType2;
